import { Flex, Grid, ReadonlyField, Text } from '@shared/components';

export interface EmployeeInformationReadonlyFieldsProps {
  blockedType: string;
  position: string;
  department: string;
}

export default function EmployeeInformationReadonlyFields(
  props: Readonly<EmployeeInformationReadonlyFieldsProps>,
) {
  const { blockedType, position, department } = props;

  return (
    <Grid
      sx={(theme) => ({
        gridTemplateColumns: '240px 1fr',
        gap: theme.spacing(6),
      })}
    >
      <Text variant='body1Semibold'>ประเภทผู้ไม่มีสิทธิ์สอบ</Text>
      <ReadonlyField
        label='ประเภทหน้าที่'
        content={blockedType}
        sx={{
          maxWidth: '600px',
        }}
      />
      <Text variant='body1Semibold'>ข้อมูลการปฏิบัติหน้าที่</Text>
      <Flex sx={(theme) => ({ gap: theme.spacing(4) })}>
        <ReadonlyField label='ตำแหน่ง' content={position} />
        <ReadonlyField label='ฝ่ายงาน/ส่วนงาน' content={department} />
      </Flex>
    </Grid>
  );
}
